import _ from 'lodash';
import moment from 'moment';

import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from './lib/create_model';

const SidePanelType = createEnum('NONE', 'ANSWER', 'TASK', 'AI_ASSIST');
export { SidePanelType };

const SidePanel = createModel({
  modelName: 'SidePanel',
  properties: {
    panelShown: prop(String)
      .oneOf(..._.keys(SidePanelType))
      .default(SidePanelType.NONE),
    panelLastShownAt: prop(String).default(''),
  },

  isOpen() {
    return this.panelShown !== SidePanelType.NONE;
  },

  isShowing(panelType) {
    return this.panelShown === panelType;
  },

  show(panelType) {
    this.panelShown = panelType;
    this.panelLastShownAt = moment().toISOString();
  },

  close() {
    this.panelShown = SidePanelType.NONE;
    this.panelLastShownAt = '';
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },

    Type: SidePanelType,
  },
});

export default SidePanel;
